import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import {
  BoxIcon,
  ChartColumnIcon,
  ClipboardListIcon,
  HouseIcon,
  LightbulbIcon,
  RocketIcon,
  SettingsIcon,
  TagIcon,
} from "lucide-react";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

type NavItem = {
  key: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
};

const OVERVIEW: NavItem[] = [
  { key: "dashboard", href: "", icon: HouseIcon },
  { key: "explore", href: "explore", icon: ChartColumnIcon },
  { key: "insights", href: "insights", icon: LightbulbIcon },
  { key: "items", href: "items", icon: BoxIcon },
];

const PLANNING: NavItem[] = [
  { key: "runs", href: "planning/runs", icon: RocketIcon },
  {
    key: "executions",
    href: "planning/executions",
    icon: ClipboardListIcon,
  },
  { key: "policies", href: "planning/policies", icon: TagIcon },
];

const SETTINGS: NavItem = {
  key: "settings",
  href: "settings",
  icon: SettingsIcon,
};

export function NavMain() {
  const { t } = useTranslation();

  const renderItem = (item: NavItem) => {
    const Icon = item.icon;
    return (
      <SidebarMenuItem key={item.key}>
        <NavLink to={item.href} end={item.href === ""}>
          {({ isActive }) => (
            <SidebarMenuButton isActive={isActive}>
              <Icon className="size-4" />
              <span>{t(`mainNavigation.${item.key}`)}</span>
            </SidebarMenuButton>
          )}
        </NavLink>
      </SidebarMenuItem>
    );
  };

  return (
    <>
      <SidebarGroup>
        <SidebarGroupLabel>
          {t("mainNavigation.groups.overview")}
        </SidebarGroupLabel>
        <SidebarGroupContent>
          <SidebarMenu>{OVERVIEW.map(renderItem)}</SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>
      <SidebarGroup>
        <SidebarGroupLabel>
          {t("mainNavigation.groups.planning")}
        </SidebarGroupLabel>
        <SidebarGroupContent>
          <SidebarMenu>{PLANNING.map(renderItem)}</SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>
      <SidebarGroup className="mt-auto">
        <SidebarGroupContent>
          <SidebarMenu>{renderItem(SETTINGS)}</SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>
    </>
  );
}
